import React from "react";
import Box from "@mui/material/Box";
import {Checkbox, Collapse, FormControlLabel, IconButton, Typography} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import StyledSlider from "../StyledSlider/StyledSlider";
import Grid from "@mui/material/Grid";
import {useTheme} from "../../../contexts/theme";
import StyledCheckBox from "../StyledCheckbox/StyledCheckBox";
import StyledDrawerComponent from "../StyledDrawerComponent/StyledDrawerComponent";
import StyledCollapse from "../StyledCollapse/StyledCollapse";

interface AudioFadingCollapseProps {
    onClose?: () => void;
    onOpen?: () => void;
    fade: boolean;
    fadeDuration: number;
    onFadeChange: (fade: boolean) => void;
    onFadeDurationChange: (fadeDuration: number) => void;
    minFadeDuration: number;
    maxFadeDuration: number;
    fadeDurationStep: number;
}

const AudioFadingCollapse: React.FC<AudioFadingCollapseProps> = ({onOpen = () => {}, onClose = () => {}, fade, onFadeChange, onFadeDurationChange, fadeDurationStep, maxFadeDuration, minFadeDuration, fadeDuration}) => {
    const theme = useTheme();

    return (


                <Grid container spacing={2} alignItems={'center'}>
                    <Grid item xs={12} md={6} lg={3}>
                        <FormControlLabel
                            sx={{color: theme.palette.white, marginLeft: '0px',}}
                            control={
                                <StyledCheckBox
                                    height={'20px'}
                                    width={'20px'}
                                    iconSize={'20px'}
                                    checked={fade}
                                    onChange={(e) => onFadeChange((e.target as any).checked)}
                                />
                            }
                            label="Audio Fading beetween clips"
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={9} sx={{marginTop: '5px'}}>
                        <StyledSlider
                            value={fadeDuration}
                            onChange={(_, newValue, __) => onFadeDurationChange(newValue as number)}
                            valueLabelDisplay={"auto"}
                            labelSlider={'Audio Fade Duration'}
                            formatLabel={(value) => `${value.toFixed(1)}s`}
                            min={minFadeDuration}
                            max={maxFadeDuration}
                            includeInputText={true}
                            inputTextLabel={'s'}
                            step={fadeDurationStep}
                            disabled={!fade}
                        />
                    </Grid>
                </Grid>


    )
}

export default AudioFadingCollapse;